$w.onReady(function () {
    $w('#button7').onClick(() => {
        toggleBox($w('#newYorkCollapsibleBox'), $w('#image36'), $w('#image35'));
    });

    $w('#tokyoCollapseButton').onClick(() => {
        toggleBox($w('#tokyoCollapsibleBox'), $w('#tokyoPlusSign'), $w('#tokyoMinusSign'));
    });

    $w('#parisCollapseButton').onClick(() => {
        toggleBox($w('#parisCollapsibleBox'), $w('#parisPlusSign'), $w('#parisMinusSign'));
    });

        $w('#button8').onClick(() => {
        toggleBox($w('#box30'), $w('#image38'), $w('#image37'));
    });

    $w('#button9').onClick(() => {
        toggleBox($w('#box35'), $w('#image40'), $w('#image39'));
    });

    $w('#button10').onClick(() => {
        toggleBox($w('#box39'), $w('#image42'), $w('#image41'));
    });
        $w('#button11').onClick(() => {
        toggleBox($w('#box41'), $w('#image44'), $w('#image43'));
    });

    $w('#button12').onClick(() => {
        toggleBox($w('#box46'), $w('#image46'), $w('#image45'));
    });

    $w('#button13').onClick(() => {
        toggleBox($w('#box50'), $w('#image48'), $w('#image47'));
    });

    $w('#button14').onClick(() => {
        toggleBox($w('#box52'), $w('#image50'), $w('#image49'));
    });
});

function toggleBox(boxElement, plusSign, minusSign) {
    const isCollapsed = boxElement.collapsed;
    if (isCollapsed) {
        plusSign.hide();
        minusSign.show();
        boxElement.expand();
    } else {
        minusSign.hide();
        plusSign.show();
        boxElement.collapse();
    }
}